/*! @azure/msal-common v16.5.2 2026-04-28 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.5.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
